const {Core, Events, Utils, MediaQueries} = Global;
const { $toggleDisplay } = Utils;
const CN_ACTIVE = '!active';
const CN_LOADING = '!loading';

customElements.define('sticky-add-to-cart', class extends Core {

    elements = {
        $: ['observer-trigger', 'wrapper']
    }

    propTypes = {
        'sticky-bottom': Boolean
    }

    render() {
        this.sub(Events.VARIANT_CHANGE, this._toggleLoading(true));
        this.sub(Events.VARIANT_UPDATE, this._toggleLoading(false));
        this.sub(Events.VARIANT_UNAVAILABLE, this._handleVariantUnavailability);

        if (this.prop('sticky-bottom')) {
            this._setBodyOffset();
        }
        
        this._handleTrigger();
    }

    _handleTrigger() {
        this.observer = new IntersectionObserver(([entry]) => {
            const isActive = !entry.isIntersecting && entry.boundingClientRect.top <= 0;
            this.active = isActive;

            if (MediaQueries.DESKTOP.matches && !this.prop('sticky-bottom')) {
                if (isActive) {
                    document.body.style.setProperty('--sticky-add-to-cart-top-offset',`${this.$('wrapper').offsetHeight}px`);
                } else {
                    document.body.style.setProperty('--sticky-add-to-cart-top-offset', '0px');
                }
            }
        });
        this.observer.observe(this.$('observer-trigger'));
    }

    _setBodyOffset() {
        document.body.style.setProperty('--bottom-offset', `${this.$('wrapper').offsetHeight}px`);
    }

    _toggleLoading(state) {
        return () => {
            this.classList.toggle(CN_LOADING, state);
        }
    }

    _handleVariantUnavailability(state) {
        $toggleDisplay(this, !state);
    }

    set active(state) {
        this.classList.toggle(CN_ACTIVE, state);
    }
})